/*
* @Author: tengmaoqing
* @Date:   2018-04-23 20:02:00
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-26 20:20:43
*/

import { getOrderDetail } from '@/apis/base';

export default {
  namespaced: true,
  state: () => {
    return {
      orderInfo: {},
      // cancelInfo: null,
      error: ''
      // remark: ''
    };
  },
  actions: {
    async getOrder ({ commit, rootState }, orderId) {
      try {
        const res = await getOrderDetail(orderId);
        commit('setOrderInfo', res._data);
        // commit('setRemark', res._data.remark);
      } catch (e) {
        console.log('order', e);
      }
    }
    // async cancelOrder ({commit}, orderId) {
    //   try {
    //     const res = await cancelOrder(orderId);
    //     if (res._errCode !== '0') {
    //       commit('setError', res._errStr);
    //     }
    //   } catch (e) {
    //     console.log('order', e);
    //   }
    // },
    // async orderRemark ({commit}, {orderId, remark}) {
    //   try {
    //     const res = await orderRemark(orderId, remark);
    //     if (res._errCode !== '0') {
    //       commit('setError', res._errStr);
    //     }
    //   } catch (e) {
    //     console.log('order', e);
    //   }
    // }
  },
  mutations: {
    setOrderInfo (state, data) {
      state.orderInfo = data;
    },
    // setCancelInfo (state, data) {
    //   state.cancelInfo = data;
    // },
    setError (state, data) {
      state.error = data;
    }
    // setRemark (state, data) {
    //   state.remark = data;
    // }
  }
};
